import { Component, Inject } from '@angular/core';
import { context } from 'bookingbug-core-js';
import { AppConfig } from './app.config';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DatastoreService } from './services/datastore.service';
import { AlertService } from './_alert';

// Required for MSAL
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  loadIssue: boolean;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private DataStore: DatastoreService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private titleService: Title) {
    translate.addLangs(['en', 'cy']);
    translate.setDefaultLang('en');
    translate.use('en');

    this.DataStore.notify.subscribe((result) => {
      this.loadIssue = result;
      this.scrollToTop();
      this.alertService.clear();
      this.alertService.error(this.translate.instant('COMMON.LOAD_ISSUE'));
    })
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects || event.url;
        const lastSegment = url.split('/').filter(Boolean).pop();
        const formatted = lastSegment.replace(/[-_]/g, ' ')
          .replace(/\b\w/g, char => char.toUpperCase());
        this.titleService.setTitle(`${formatted} | London Borough of Havering`);

        if (!url.includes('start')) {
          setTimeout(() => {
            const main = document.getElementById('main-content');
            main?.focus();
          }, 0);
        }
      });
      
    // BB Context storage
    console.log(AppConfig.settings);
    context.apiUrl = AppConfig.settings.apiServer.api_url;
    context.apiVersion = AppConfig.settings.apiServer.version;
    localStorage.removeItem('auth_token'); // remove any existing auth tokens
    
    this.route.queryParams.subscribe((params: any) => {
      for (const param of Object.keys(params)) {
        if (param === 'admin-only' && params[param]) {
          this.DataStore.adminJourney = true;
          console.log('This is an admin journey');
        }
        if (param === 'auth_token' && params[param]) {
          console.log('Auth token', params[param]);
          this.DataStore.adminAuthToken = params[param];
          localStorage.setItem('auth_token', params[param]);
          context.isAdmin = true;
        }
      }

      
      // if these exist then go to the ?admin=true journey
      // make sure we arent on the admin journey already
      if (window.location.pathname.indexOf('payment-verify') === -1) {
        if (localStorage.getItem('auth_token') && localStorage.getItem('agent') && !this.DataStore.adminJourney) {
          console.log('Admin journey detected from localStorage');
          this.DataStore.adminJourney = true;
          this.DataStore.adminAuthToken = localStorage.getItem('auth_token');
          context.isAdmin = true;
          // naviage to /services?admin-only=true
          window.location.assign(`/services?admin-only=true&auth_token=${this.DataStore.adminAuthToken}`);
        }
      }
    })

  }

  skipToMainContent(event: Event) {
    event.preventDefault(); // Prevent default anchor behavior
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
    }
  }

  scrollToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
        window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }
}

